import React from 'react';

import { CssCheckIcon, CssControlEnd } from './vbCssComponents';

class VBControlEnd extends React.Component {
    constructor(props){
        super();

        this.state={
            width: null
        }

        this.container = React.createRef();
    }

    getWidth(){
        if(this.props.icon){
            return this.container.current.offsetWidth + "px"
        } else{
            return this.container.current.offsetWidth + 24 + "px"
        }
    }//padding for input for icons

    render() {
        return (
            <CssControlEnd ref={this.container} className="absolute flex items-center" onClick={() => {if(this.props.onClick){this.props.onClick()}}}>
                {this.props.suffix ? 
                    <span className="self-center block pr-2">{this.props.suffix}</span> 
                :null}
                <CssCheckIcon className={this.props.icon}></CssCheckIcon>
            </CssControlEnd>
        );
    }
}

export default VBControlEnd;